"use strict";

require("./bootstrap");

Vue.component("MainMenu", require("./components/menu/MainMenu.vue").default);
Vue.component("Explanation", require("./components/general/Explanation.vue").default);
Vue.component("RightMenuWrapper", require("./components/menu/RightMenuWrapper.vue").default);
Vue.component("PrintTest", require("./components/printtest/PrintTest.vue").default);

Vue.component("Token", require("./components/elements/Token.vue").default);
Vue.component("Method", require("./components/elements/Method.vue").default);
Vue.component("DropdownField", require("./components/elements/DropdownField.vue").default);
Vue.component("IconDropdownField", require("./components/elements/IconDropdownField.vue").default);
Vue.component("MultiSelectField", require("./components/elements/MultiselectField.vue").default);
Vue.component("TextareaField", require("./components/elements/TextareaField.vue").default);
Vue.component("Datepicker", require("./components/elements/DatePicker.vue").default);
Vue.component("MessageBlock", require("./components/elements/MessageBlock.vue").default);

//LOGIN
Vue.component("LoginForm", require("./components/login/LoginForm.vue").default);
Vue.component("LoginFormBankId", require("./components/login/LoginFormBankId.vue").default);
Vue.component("LoginFormEmail", require("./components/login/LoginFormEmail.vue").default);
Vue.component("ForgotPassword", require("./components/login/ForgotPassword.vue").default);

Vue.component("SignupForm", require("./components/login/SignUpForm.vue").default);
Vue.component("SignupFormBankId", require("./components/login/SignUpFormBankId.vue").default);
Vue.component("SignupFormEmail", require("./components/login/SignUpFormEmail.vue").default);
Vue.component("InputField", require("./components/elements/InputField.vue").default);
Vue.component("FileInput", require("./components/elements/FileInput.vue").default);
Vue.component("SocialIcon", require("./components/elements/SocialIcon.vue").default);

Vue.component("TestForm", require("./components/forms/TestForm.vue").default);
Vue.component("ShowTest", require("./components/tests/ShowTest.vue").default);
Vue.component("ShowInbodyTest", require("./components/tests/InBody/ShowInBodyTest.vue").default);
Vue.component("HealthGoalItem", require("./components/lists/HealthGoalItem.vue").default);
Vue.component("Report", require("./components/reports/Report.vue").default);
Vue.component("Flash", require("./components/notifiers/Flash.vue").default);

Vue.component("DashboardCard", require("./components/cards/DashboardCard.vue").default);

// Right menu
Vue.component("ProfileMenu", require("./components/menu/ProfileMenu.vue").default);
Vue.component("AddHealthGoalMenu", require("./components/menu/AddHealthGoalMenu.vue").default);

Vue.component("EditProfileMenu", require("./components/menu/EditProfileMenu.vue").default);
Vue.component("EditHealthGoalMenu", require("./components/menu/EditHealthGoalMenu.vue").default);
Vue.component("BookTimeMenu", require("./components/menu/BookTimeMenu.vue").default);
Vue.component("DeleteConfirmation", require("./components/menu/DeleteConfirmation.vue").default);

Vue.component("DeleteBookingButton", require("./components/dashboard/DeleteBookingButton.vue").default);

// Terms
Vue.component("TermsForm", require("./components/terms/TermsForm.vue").default);
Vue.component("ShowTerms", require("./components/terms/ShowTerms.vue").default);

// Dashboard
Vue.component("Dashboard", require("./components/dashboard/Dashboard.vue").default);
Vue.component("DashboardHealthGoals", require("./components/dashboard/HealthGoals.vue").default);
Vue.component("DashboardNoTests", require("./components/dashboard/NoTests.vue").default);
Vue.component("DashboardWelcome", require("./components/dashboard/WelcomeBlock.vue").default);
Vue.component("DashboardOccasion", require("./components/dashboard/occasions/Occasion.vue").default);
Vue.component("DashboardOccasionActions", require("./components/dashboard/occasions/Actions.vue").default);
Vue.component("DashboardOccasionStatus", require("./components/dashboard/occasions/Status.vue").default);
Vue.component("DashboardOccasionSummary", require("./components/dashboard/occasions/Summary.vue").default);
Vue.component("DashboardChartList", require("./components/dashboard/ChartList.vue").default);
Vue.component("DashboardChartListItem", require("./components/dashboard/ChartListItem.vue").default);

// Site blocks
Vue.component("AppFooter", require("./components/general/Footer.vue").default);
Vue.component("AppHeader", require("./components/general/Header.vue").default);
Vue.component("MainMenuAdmin", require("./components/menu/MainMenuAdmin").default);
Vue.component("MainMenuUser", require("./components/menu/MainMenuUser").default);
Vue.component("LocaleSwitcher", require("./components/general/LocaleSwitcher").default);
Vue.component("UnsupportedBrowser", require("./components/general/UnsupportedBrowser").default);

// Test
Vue.component("TestSummary", require("./components/tests/TestSummary").default);

// Forms
Vue.component("ErrorsList", require("./components/forms/ErrorsList.vue").default);

// Messages
Vue.component("EmailSmsBlock", require("./components/elements/EmailSMSBlock").default);

// Custom components
Vue.component("RequestErrors", require("./components/general/RequestErrors.vue").default);
Vue.component("TelInput", require("./components/elements/TelInput/TelInput").default);

require("./app.js");


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/client.js
// module id = ddhG
// module chunks = 1